import { useCallback, useLayoutEffect, useRef } from 'react';

// Turns the selected ids into one string key. isStale(key) tells if a response was fetched with
// an older filter, so it can be dropped.
export function useFilterKey(
  deviceIds: string[] | undefined,
  sectionIds: string[] | undefined,
) {
  const filterKey = JSON.stringify([deviceIds, sectionIds]);
  const currentFilterKey = useRef(filterKey);
  // Updated after commit so an in-flight response is compared against the committed filter.
  useLayoutEffect(() => {
    currentFilterKey.current = filterKey;
  }, [filterKey]);
  const isStale = useCallback(
    (key: string) => key !== currentFilterKey.current,
    [],
  );
  return { filterKey, isStale };
}
